import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHelp from './help.reducer';

export const selectHelpState = createFeatureSelector<fromHelp.HubHelpState>(
  fromHelp.featureKey
);

export const getHelpVisible = createSelector(selectHelpState, (state) => state.helpVisible);
export const getOnBoardingEnabled = createSelector(selectHelpState, (state) => state.onBoardingEnabled);
export const getHasPageGuide = createSelector(selectHelpState, (state) => state.pageGuideCount > 0);
